/* eslint-disable react/prop-types */

import React from 'react';
import { Card, CardFooter, CardBody, Alert } from 'reactstrap';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  adminInstance as axios,
  toastSuccess,
} from '~/utils';
import { Button, Field, FormAlerts, useFeatures } from '@cordata/buffet';

const formEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    notificationGroupName: Yup.string().required(),
    notificationGroupLabel: Yup.string().required(),
  }),

  mapPropsToValues: (props) => {
    const attrs = props.data ? { ...props.data.attributes } : {};

    return {
      id: props.data && props.data.id,
      ...attrs,
    };
  },

  handleSubmit: (values, { setErrors, setSubmitting, ...bag }) => {
    const { props: { history } } = bag;

    const p = {
      notificationGroupLabel: values.notificationGroupLabel,
      notificationGroupName: values.notificationGroupName,
      orgUid: localStorage.getItem('org'),
      isInSelections: true,
    };

    if (!values.id) {
      axios
        .post('/notification-group', p)
        .then(() => toastSuccess())
        .then(() => history.push('/admin/reminder-groups'))
        .catch((e) => {
          setErrors({
            server: e.response.data,
            ...e.response.data.errors,
          });
        })
        .then(() => setSubmitting(false));
    } else {
      axios
        .put(`/notification-group/${values.id}`, p)
        .then(() => toastSuccess())
        .then(() => history.push('/admin/reminder-groups'))
        .catch((e) => {
          setErrors({
            server: e.response.data,
            ...e.response.data.errors,
          });
        })
        .then(() => setSubmitting(false));
    }
  },

  displayName: 'ReminderGroupsForm',
  validateOnChange: false,
  validateOnBlur: false,
});

const ReminderGroupsForm = ({
  values,
  errors,
  handleSubmit,
  isSubmitting,
  submitCount,
}) => {
  const { hasAppKickstarter } = useFeatures();

  return (
    <Card>
      <form noValidate>
        <CardBody>
          { submitCount >= 1 && errors && !errors.orgUid && <FormAlerts errors={errors} /> }
          { submitCount >= 1 && errors && errors.orgUid && <Alert color="danger">We are unable to complete this action.<hr />Organization is required.</Alert> }

          <Field
            name="notificationGroupLabel"
            label="Label"
            required
          />

          <Field
            name="notificationGroupName"
            label="Name"
            disabled={values.id}
            required
          />

          {hasAppKickstarter && (
            <Field
              name="id"
              placeholder=" "
              disabled
            />
          )}
        </CardBody>

        <CardFooter className="d-flex">
          <div className="ml-auto">
            <Button
              type="cancel"
              disabled={isSubmitting}
              tag={Link}
              to="/admin/reminder-groups"
            >
              Cancel
            </Button>

            <Button type="button" color="primary" disabled={isSubmitting} onClick={handleSubmit}>
              <FontAwesomeIcon icon="save" className="mr-2" />
              {isSubmitting ? 'Working ...' : 'Save'}
            </Button>
          </div>
        </CardFooter>
      </form>
    </Card>
  );
};

export default withRouter(formEnhancer(ReminderGroupsForm));
